export const IMAGES = {
  DEFAULT_AVATAR: require("../images/Avatarprofile.png"),
};
